import { toPublicMediaUrl } from "@/app/lib/media";

export const getBlogCoverImageUrl = (slug: string) =>
  toPublicMediaUrl(`images/blogs/${slug}.webp`);
